(function () {
    'use strict';
    const newHasClass = document.getElementsByClassName('tpl-blog-overview');
    const blogsHasClass = document.getElementsByClassName('tpl-news-overview');

    if (newHasClass.length > 0 || blogsHasClass.length > 0) {
        var delay = 4;

        var swiper = new Swiper('.content-header-swiper-cards', {
            spaceBetween: 25,
            slidesPerView: 1,
            watchOverflow: true,
            centeredSlides: true,
            autoplay: {
                delay: delay * 1000,
            },

            watchSlidesProgress: true,
            breakpoints: {
                768: {
                    slidesPerView: 1,
                },
                1024: {
                    slidesPerView: 3,
                    allowTouchMove: false,
                    centeredSlides: false,
                },
            },
        });
        var swiper2 = new Swiper('.content-header-swiper-images', {
            watchOverflow: true,
            autoplay: {
                delay: delay * 1000,
            },

            allowTouchMove: false,
            effect: 'fade',
            thumbs: {
                swiper: swiper,
            },
        });

        function match(e) {
            const slides = swiper.el.querySelectorAll('.swiper-slide');
            slides.forEach(function (el, i) {
                function to() {
                    swiper.slideTo(i);
                    swiper2.slideTo(i);
                }
                if (!e.matches) {
                    el.addEventListener('mouseover', to, true);
                }
            });
        }

        const windowWidth = window.matchMedia('(max-width: 1024px)');
        match(windowWidth);
        windowWidth.addEventListener('change', (e) => {
            match(e);
        });

        swiper.on('slideChange', function (e) {
            swiper2.slideTo(e.activeIndex);
        });
    }
    return null;
})();
